<template>
    <el-dialog
            width="30%"
            title="添加标签"
            :modal="false"
            @close="close()"
            :visible="true"
            :close-on-click-modal="false"
            class="close">
        <el-form label-width="120px" size="mini">
            <el-form-item label="标签名称:" required>
                <el-input v-model="formPost.bt_name" placeholder="标签名最多八个字符"></el-input>
            </el-form-item>
            <el-form-item label="上传标签图片:" required>
                <el-upload
                        class="avatar-uploader"
                        action="/index.php/page/Decoration/upload"
                        name="image"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess1">
                    <img v-if="formPost.img" :src="formPost.img" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
            </el-form-item>
        </el-form>

        <div slot="footer">
            <el-button size="mini" @click="close()" title="取消">取 消</el-button>
            <el-button size="mini" type="primary" @click="handleConfirm()" title="确定提交">确 定</el-button>
        </div>
    </el-dialog>
</template>

<style>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>

<script>
    export default {
        props: {

        },
        watch: {

        },
        data() {
            return {
                formPost: {
                    bt_name: '',
                    img: '',
                },
            }
        },
        mounted() {
        },
        methods: {
            handleAvatarSuccess1(response, file) {
                if (response.error === 0) {
                    this.formPost.img = response.data
                } else {
                    this.$message.error(response.message)
                }
            },
            handleConfirm() {
                let that = this
                this.$ajax.post('page/Decoration/add', this.formPost).then(function (res) {
                    if (res.data.error === 0) {
                        that.$emit('callback', true)
                    } else {
                        that.$message(res.data.message)
                    }
                })
            },
            close() {
                this.$emit('callback', false)
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/page/decoration/Add.vue